import {
  absoluteImage,
  absoluteUrl,
  DEFAULT_SEO_PUBLISHER,
  stripHtml,
} from "../config/seo";

const truncate = (s: string, maxLen: number) => {
  const text = s.trim();
  if (!text) return "";
  if (text.length <= maxLen) return text;
  return `${text.slice(0, maxLen).trim()}...`;
};

export const buildkalyanDescription = (kalyan: any) => {
  const html = kalyan?.description ?? kalyan?.intro ?? "";
  const text = stripHtml(html);
  return truncate(text, 160);
};

export const buildkalyanKeywords = (kalyan: any) => {
  const parts = [kalyan?.author, kalyan?.kalyanLanguage, kalyan?.name]
    .map((v: any) => (v ? String(v).trim() : ""))
    .filter(Boolean);

  const uniq: string[] = [];
  for (const p of parts) {
    const key = p.toLowerCase();
    if (!uniq.some((x) => x.toLowerCase() === key)) uniq.push(p);
  }

  return uniq.join(", ");
};

export const buildkalyanJsonLd = (kalyan: any, canonicalPath: string) => {
  const url = absoluteUrl(canonicalPath);
  const seoImage = kalyan?.ogImage || kalyan?.kalyanPath || "";
  const image = seoImage ? absoluteImage(seoImage) : "";
  const description = buildkalyanDescription(kalyan);
  const authorName = kalyan?.author ? String(kalyan.author).trim() : "";
  const name = kalyan?.name ? String(kalyan.name).trim() : "";
  const inLanguage = kalyan?.kalyanLanguage ? String(kalyan.kalyanLanguage).trim() : "";

  const jsonLd: Record<string, any> = {
    "@context": "https://schema.org",
    "@type": "kalyan",
    name: name || undefined,
    url: url || undefined,
    ...(description ? { description } : {}),
    ...(image ? { image } : {}),
    ...(authorName ? { author: { "@type": "Person", name: authorName } } : {}),
    ...(inLanguage ? { inLanguage } : {}),
    publisher: { "@type": "Organization", name: DEFAULT_SEO_PUBLISHER },
  };

  // Remove undefined properties so schema is cleaner.
  for (const key of Object.keys(jsonLd)) {
    if (jsonLd[key] === undefined) delete jsonLd[key];
  }

  return jsonLd;
};

